import { showSuccess, showWarning, showError } from "../utils/toast";

/**
 * Runs Excel logic and shows proper toast
 */
export async function runExcelWithToast({
  action,
  successMessage,
}) {
  try {
    const result = await action();

    showSuccess(successMessage || "Operation completed");

    return result;

  } catch (err) {
    // Formatting / busy errors → warning
    if (
      err?.code === "0x8002000B" ||
      err?.message?.includes("0x8002")
    ) {
      showWarning("Saved successfully (minor Excel refresh issue)");
      return;
    }

    // Real failure
    showError("Failed to save. Please try again.");
    throw err;
  }
}
